import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2"; // Import SweetAlert2
import BASE_URL from "../config";
const AddClient = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        contact_type: "",
        country: "",
        other_contact: "",
        email: "",
        website: "",
        payment_type: "monthly",
        asset_type: "",
        payment_mode: "",
        last_payment_date: "",
        next_due_date: "",
        domain_info: "",
        server_info: "",
        email_info: "",
    });

    const [validated, setValidated] = useState(false);

    useEffect(() => {
        const today = new Date().toISOString().split("T")[0];
        setFormData(prevData => ({ ...prevData, last_payment_date: today }));
        updateNextDueDate(today, "monthly");
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: value }));

        if (name === "last_payment_date" || name === "payment_type") {
            updateNextDueDate(
                name === "last_payment_date" ? value : formData.last_payment_date,
                name === "payment_type" ? value : formData.payment_type
            );
        }
    };

    const updateNextDueDate = (lastPaymentDate, paymentType) => {
        if (!lastPaymentDate) return;

        let nextDueDate = new Date(lastPaymentDate);

        switch (paymentType.toLowerCase()) {
            case "monthly":
                nextDueDate.setMonth(nextDueDate.getMonth() + 1);
                break;
            case "biweekly":
                nextDueDate.setDate(nextDueDate.getDate() + 15);
                break;
            case "yearly":
                nextDueDate.setFullYear(nextDueDate.getFullYear() + 1);
                break;
            case "quarterly":
                nextDueDate.setMonth(nextDueDate.getMonth() + 3);
                break;
            case "onetime":
                setFormData(prevData => ({ ...prevData, next_due_date: "" }));
                return;
            default:
                return;
        }

        if (!isNaN(nextDueDate.getTime())) {
            setFormData(prevData => ({
                ...prevData,
                next_due_date: nextDueDate.toISOString().split("T")[0],
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }
        setValidated(true);
        console.log(JSON.stringify(formData));
        try {
            const token = localStorage.getItem("token");
            const clientResponse = await fetch(`${BASE_URL}api/clients/create`, {
                method: "POST",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                body: JSON.stringify(formData),
            });

            if (!clientResponse.ok) throw new Error("Failed to create client");

            const clientData = await clientResponse.json();
            if (!clientData.client || !clientData.client.id) {
                throw new Error("Client ID missing in response");
            }

            if (formData.payment_type.toLowerCase() !== "onetime") {
                const paymentData = {
                    client_id: clientData.client.id,
                    last_payment_date: formData.last_payment_date,
                    next_due_date: formData.next_due_date,
                };
                const token = localStorage.getItem("token");
                const paymentResponse = await fetch(`${BASE_URL}api/payment/create`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                    body: JSON.stringify(paymentData),
                });

                if (!paymentResponse.ok) {
                    throw new Error("Failed to create payment record");
                }
            }

            Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Client and payment record created successfully!",
            }).then((result) => {
                if (result.isConfirmed || result.isDismissed) {
                    navigate("/clients"); // Redirect to the clients page
                }
            });
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Error occurred while creating client or payment record.",
            });
        }
    };
    return (
        <div className="clients mt-4 mx-3">
            <h2 className="mb-3">Add Client</h2>
            <form onSubmit={handleSubmit} noValidate className={validated ? "was-validated" : ""}>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Client Name</label>
                        <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
                        <div className="invalid-feedback">Client name is required.</div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Phone</label>
                        <input
                            type="text"
                            className="form-control"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                        />
                        <div className="invalid-feedback">Please enter a valid phone number.</div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Contact Type</label>
                        <select className="form-control" name="contact_type" value={formData.contact_type} onChange={handleChange} required>
                            <option value="">Select</option>
                            <option value="Whatsapp">Whatsapp</option>
                            <option value="Skype">Skype</option>
                            <option value="Email">Email</option>
                        </select>
                        <div className="invalid-feedback">Please select a contact type.</div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Country</label>
                        <input type="text" className="form-control" name="country" value={formData.country} onChange={handleChange} required />
                        <div className="invalid-feedback">Please Enter a country.</div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Other Contact</label>
                        <input type="text" className="form-control" name="other_contact" value={formData.other_contact} onChange={handleChange} required />
                        <div className="invalid-feedback">Only numbers are allowed.</div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Email</label>
                        <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} required />
                        <div className="invalid-feedback">Please enter a valid email.</div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Website</label>
                        <input type="text" className="form-control" name="website" value={formData.website} onChange={handleChange} required />
                        <div className="invalid-feedback">Please enter a Website.</div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Payment Type</label>
                        <select className="form-control" name="payment_type" value={formData.payment_type} onChange={handleChange} required>
                            <option value="Monthly">Monthly</option>
                            <option value="Biweekly">Biweekly</option>
                            <option value="Quarterly">Quarterly</option>
                            <option value="Yearly">Yearly</option>
                            <option value="Onetime">Onetime</option>
                        </select>
                        <div className="invalid-feedback">Please Select a Payment Type.</div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Asset Type</label>
                        <select className="form-control" name="asset_type" value={formData.asset_type} onChange={handleChange} required>
                            <option value="">Select Asset Type</option>
                            <option value="Website Hosting">Website Hosting</option>
                            <option value="Domain">Domain</option>
                            <option value="Emails">Emails</option>
                            <option value="Others">Others</option>
                        </select>
                        <div className="invalid-feedback">Please Select a Asset Type.</div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Payment Mode</label>
                        <select className="form-control" name="payment_mode" value={formData.payment_mode} onChange={handleChange} required>
                            <option value="">Select Payment Mode</option>
                            <option value="Standard Chartered">Standard Chartered</option>
                            <option value="Payoneer">Payoneer</option>
                            <option value="JazzCash">JazzCash</option>
                            <option value="Cash">Cash</option>
                        </select>
                        <div className="invalid-feedback">Please Select a Payment Mode.</div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label for="last_payment_date" className="form-label">Last Payment Date</label>
                        <input type="date" id="last_payment_date" className="form-control" name="last_payment_date" value={formData.last_payment_date} onChange={handleChange} required />
                        <div className="invalid-feedback">Please Select a Last Payment Date.</div>
                    </div>

                    <div className="col-md-6">
                        <label for="next_due_date" className="form-label">Next Due Date</label>
                        <input id="next_due_date" type="date" className="form-control" name="next_due_date" value={formData.next_due_date} onChange={handleChange} required />
                        <div className="invalid-feedback">Please Select a Next Due Date.</div>
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label">Domain Info</label>
                    <textarea className="form-control" name="domain_info" value={formData.domain_info} onChange={handleChange} required></textarea>
                    <div className="invalid-feedback">Please enter a Domain Info.</div>
                </div>

                <div className="mb-3">
                    <label className="form-label">Server Info</label>
                    <textarea className="form-control" name="server_info" value={formData.server_info} onChange={handleChange} required></textarea>
                    <div className="invalid-feedback">Please enter a Server Info.</div>
                </div>

                <div className="mb-3">
                    <label className="form-label">Email Info</label>
                    <textarea className="form-control" name="email_info" value={formData.email_info} onChange={handleChange} required></textarea>
                    <div className="invalid-feedback">Please enter a Email Info.</div>
                </div>

                <button type="submit" className="btn btn-primary">Save Client</button>
                <a href="/clients" className="btn btn-secondary ms-2">Cancel</a>
            </form>
        </div>
    );
};

export default AddClient;
